<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<!-- main row for all icons  -->
			<div class="col-lg-12">
				<div class="card card-primary card-outline">

					<div class="card-header">
						Pending Deliveries
					</div>
					<div class="card-body overflow-auto">
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
										<input class="form-control" type="text" placeholder="Enter gatepass" v-model="filters.gatepass">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<input class="form-control" type="number" placeholder="Enter mobile number" v-model="filters.mobile" min="1000000000">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<input class="form-control" type="date" placeholder="From date" v-model="filters.from_date">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<input class="form-control" type="date" placeholder="To date" v-model="filters.to_date">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<v-select v-model="filters.dp_id" :options="deliverypartners" label="name" :reduce="deliverypartners => deliverypartners.id" @input="getRest"></v-select>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<select class="form-control" v-model="filters.driver_id">
											<option v-for="driver in drivers" :value="driver.id">{{driver.lead_profile.name}}</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<select class="form-control" v-model="filters.vehicle_id">
											<option v-for="vehicle in vehicles" :value="vehicle.id">{{vehicle.make}}, {{vehicle.model}}, {{vehicle.color}}, {{vehicle.reg_no}}</option>
										</select>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<v-select v-model="filters.status" :options="deliverystatuses" label="status" :reduce="deliverystatuses => deliverystatuses.status"></v-select>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<button class="btn btn-primary" @click="getDeliveries('/api/deliveriesReport')">Search</button>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<button class="btn btn-success" @click="exportReport"><i class="fa fa-print"></i>Export</button>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<button class="btn btn-danger" @click="resetFilters"><i class="fa fa-times"></i>Reset</button>
									</div>
								</div>
							</div>
						</div>
						<table class="table table-hover table-striped table-bordered">
							<thead>
								<tr>
									<th scope="col">Gatepass</th>
									<th scope="col">Delivery Partner</th>
									<th scope="col">Driver</th>
									<th scope="col">Vehicle</th>
									<th scope="col">Delivery Status</th>
									<th scope="col">Payment Status</th>
									<th scope="col">Manage</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="delivery in deliveries">
									<td>{{delivery.gatepass_id}} {{delivery.order.customer_name}} {{delivery.order.phone_number}}</td>
									<td><p v-if="delivery.delivery_partner != null">{{delivery.delivery_partner.name}}</p></td>
									<td><p v-if="delivery.delivery_driver != null">{{delivery.delivery_driver.lead_profile.name}}</p></td>
									<td><p v-if="delivery.delivery_vehicle != null">{{delivery.delivery_vehicle.reg_no}}</p></td>
									<td>{{delivery.delivery_status}}</td>
									<td>{{delivery.gatepass.payment_status.status}}</td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-footer">
						<pagination :pagination="pagination"
						 	@prev="getDeliveries(pagination.prevPageUrl)"
						  @next="getDeliveries(pagination.nextPageUrl)"
						></pagination>
					</div>
				</div>
			</div>
<!-- row end -->
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
</div>
</template>

<script>
		import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        created(){
        	this.getDeliveries();
        	this.getDeliveryPartners();
        	this.getDeliveryStatuses();
        },

        components: {pagination:Pagination},

        data(){
        	return {
        		deliveries: [],
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		deliverypartners: [],
            drivers: [],
            vehicles: [],
            filters: new Form({
            	gatepass: null,
            	mobile: null,
            	from_date: null,
            	to_date: null,
            	dp_id: null,
            	driver_id: null,
            	vehicle_id: null,
            	status: null
            }),
            deliverystatuses: []
        	}
        },

        methods: {
        	getDeliveryStatuses(){
        		axios.post("/api/getDeliveryStatuses")
        		.then(response => {
        			this.deliverystatuses = response.data;
        		})
        	},

        	getDeliveries(url="/api/deliveriesReport"){
        		axios({
        			url: url,
        			data: {
		      			gatepass: this.filters.gatepass,
		          	mobile: this.filters.mobile,
		          	from_date: this.filters.from_date,
		          	to_date: this.filters.to_date,
		          	dp_id: this.filters.dp_id,
		          	driver_id: this.filters.driver_id,
		          	vehicle_id: this.filters.vehicle_id,
		          	status: this.filters.status
		          },
		          method: 'post',
		          headers: { 'Content-Type': 'application/json' }
            })
        		.then(response => {
        			this.deliveries = response.data.data.data;
        			this.configPagination(response.data.data);
        		});
        	},

        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

    			exportReport(){
        		axios({
							url: "/api/deliveriesReportExport",
							data: {
		      			gatepass: this.filters.gatepass,
		          	mobile: this.filters.mobile,
		          	from_date: this.filters.from_date,
		          	to_date: this.filters.to_date,
		          	dp_id: this.filters.dp_id,
		          	driver_id: this.filters.driver_id,
		          	vehicle_id: this.filters.vehicle_id,
		          	status: this.filters.status
		          },
							method: 'post',
							responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Report Generated'
        			})
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			saveAs(response.data, "deliveries_report.xlsx");
        		});
        	},

        	getDeliveryPartners(){
        		axios.post("/api/getAllDeliveryPartners")
        		.then(response => {
        			this.deliverypartners = response.data;
        		})
        	},

        	getRest(){
        		axios.post("/api/getPartnerDrivers", {dp: this.filters.dp_id, paginate: false})
        		.then(response => {
        			this.drivers = response.data;
        		})
        		axios.post("/api/getPartnerVehicles", {dp: this.filters.dp_id, paginate: false})
        		.then(response => {
        			this.vehicles = response.data;
        		})
        	},

        	resetFilters(){
        		this.filters.reset();
        		this.getDeliveries();
        	}
        }
    }
</script>
